import type { IconDefinition, IconName, IconPrefix } from "@fortawesome/pro-light-svg-icons";

let lastIconId = 0xe001;
const getNextIconId = () => {
    lastIconId++;
    return lastIconId.toString(16);
};

const irIcon = (name: string, svgPath: string) =>
    ({
        iconName: name as IconName,
        prefix: "ir" as IconPrefix,
        icon: [20, 20, [], getNextIconId(), svgPath],
    } as IconDefinition);

export const analysisEnabled = irIcon(
    "analysis-enabled",
    "M10,4C4.5,4,0,8.4,0,10s4.5,6,10,6s10-4.4,10-6S15.5,4,10,4z M10,14.9c-2.6,0-4.7-2.2-4.7-4.9S7.4,5.1,10,5.1 s4.7,2.2,4.7,4.9S12.6,14.9,10,14.9z M13.7,10c0,2.1-1.6,3.8-3.7,3.8S6.3,12.1,6.3,10c0-1,0.4-2,1.1-2.7c0,0.6,0.5,1,1,1 c0.6,0,1.1-0.5,1.1-1.1c0-0.4-0.2-0.7-0.5-0.9c0.3-0.1,0.7-0.2,1-0.2C12,6.2,13.7,7.9,13.7,10z",
);
export const analysisDisabled = irIcon(
    "analysis-disabled",
    "M13.4,14.1l1.5,1.5c-1.4,0.7-3.1,1.1-4.9,1.1c-5.5,0-10-4.4-10-6c0-1.1,2.1-3.5,5.1-4.9l1.5,1.5c-0.8,0.9-1.3,2.1-1.3,3.4 c0,2.7,2.1,4.9,4.7,4.9C11.3,15.6,12.5,15,13.4,14.1z M10,4.7C8.5,4.7,7.1,5,5.8,5.5l1.3,1.3c0.8-0.6,1.8-1,2.9-1 c2.6,0,4.7,2.2,4.7,4.9c0,1.1-0.3,2-0.9,2.8l1.7,1.7c2.7-1.4,4.4-3.5,4.4-4.6C20,9.1,15.5,4.7,10,4.7z M13.1,12.8 c0.4-0.6,0.6-1.3,0.6-2.1c0-2.1-1.6-3.8-3.7-3.8C9.6,6.9,9.3,7,9,7.1C9.3,7.3,9.5,7.6,9.5,8c0,0.3-0.2,0.6-0.4,0.8L13.1,12.8z M7.4,8.1L7.4,8.1c-0.7,0.6-1.1,1.6-1.1,2.6c0,2.1,1.6,3.8,3.7,3.8c1,0,2-0.5,2.6-1.2L8.3,9.1C7.8,9,7.5,8.6,7.4,8.1z M18.5,17.3 L18.5,17.3c0.3-0.3,0.3-0.8,0-1.1L5.5,3.2c-0.3-0.3-0.8-0.3-1.1,0l0,0C4.1,3.5,4.1,4,4.4,4.3l12.9,12.9 C17.7,17.6,18.2,17.6,18.5,17.3z",
);
export const analysisPartiallyEnabled = irIcon(
    "analysis-partially-enabled",
    "M10.7,18l0-16c0-0.4,0.3-0.7,0.7-0.7h0.1c0.4,0,0.7,0.3,0.7,0.7l0,16c0,0.4-0.3,0.7-0.7,0.7h-0.1C11,18.7,10.7,18.4,10.7,18 z M10,15.2c-2.6,0-4.7-2.2-4.7-4.9c0-2.7,2.1-4.9,4.7-4.9V4.3c-5.5,0-10,4.4-10,6s4.5,6,10,6V15.2z M10,6.4c-0.4,0-0.7,0.1-1,0.2 c0.3,0.2,0.5,0.5,0.5,0.9c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1-0.5-1-1c-0.7,0.7-1.1,1.6-1.1,2.7c0,2.1,1.6,3.8,3.7,3.8V6.4z",
);
